module.exports = __webpack_public_path__ + "img/edit_icon.201e6431.svg";